import { Ng1StateDeclaration, StateParams } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { dashboardRouteName, Roles } from '../../common/constants';
import { IGroupService } from '../../services';

const states: Ng1StateDeclaration[] = [
    {
        name: dashboardRouteName,
        url: `/${dashboardRouteName}/:dashboardName/:maximized?/:beginDate?/:endDate?/:groupGuid?`,
        component: 'wtDashboard',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator, Roles.reader
            ]),
            group: [
                '$stateParams', 'groupService', ($stateParams: StateParams, groupService: IGroupService) => {
                    if ($stateParams.groupGuid) {
                        return groupService.getByGuid($stateParams.groupGuid)
                            .then(data => data.group);
                    }
                    return;
                }
            ]
        },
        params: {
            groupGuid: '',
            beginDate: '',
            endDate: '',
            maximized: 'false'
        },
        data: {
            visible: false,
            isMobileVisible: true,
            isAuthenticated: true,
            isConnected: true,
            icon: 'fa-th-large',
            displayName: 'Dashboard',
            editRoles: [Roles.master, Roles.engineer],
            editButtonVisibility: () => true,
            breadcrumbs: {
                level3StateName: 'dashboards',
                level4: ''
            }
        },
    }
];

export default states;